import React from "react";
import { Form, Button, DropdownButton, Dropdown, Modal } from "react-bootstrap";
import { IoIosCloseCircle } from 'react-icons/io';

const ScheduleForm1 = ({
  scheduleParams,
  handleChange,
  selectedWeekdays,
  daysOfWeek,
  handleWeekdayClick,
  startTime,
  endTime,
  handleTimeChange,
  errorMessage,
  handleDropdownChange,
  IntervalTimePicker,
  handleCloseModal,
  showErrors = false // Add this prop
}) => {
  // Validation checks
  const isNameValid = scheduleParams?.name?.trim()?.length > 0;
  const areWeekdaysSelected = selectedWeekdays?.length > 0;
  const fromTime = scheduleParams?.schedule_time?.[0]?.schedule_from_time;
  const toTime = scheduleParams?.schedule_time?.[0]?.schedule_to_time;
  const areTimesValid = fromTime && toTime && fromTime < toTime;
  const isStatusSelected = !!scheduleParams?.machine_status;

  return (
    <>
      <Modal.Header className="flex-column align-items-center text-center mb-4">
        <Modal.Title>Create schedule</Modal.Title>
        <p className="text-muted small mb-0 mt-1">
          Create a schedule for your equipment <em>(e.g. lunch break)</em>. 
          If the equipment status does not match the schedule settings, 
          the equipment shown in your slides will blink red.
        </p>
        <div className="cross-close" onClick={handleCloseModal}>
          <IoIosCloseCircle />
        </div>
      </Modal.Header>

      <div className="form-wrapper px-3">
        {/* Schedule name */}
        <Form.Group className="mb-3">
          <Form.Label>Schedule name</Form.Label>
          <Form.Control
            className="shadow-sm"
            type="text"
            name="name"
            placeholder="Enter schedule name"
            value={scheduleParams?.name || ''}
            onChange={handleChange}
            isInvalid={showErrors && !isNameValid}
          />
          <Form.Control.Feedback type="invalid">
            Schedule name is required
          </Form.Control.Feedback>
        </Form.Group>

        {/* Select weekdays */}
        <Form.Group className="mb-3">
          <Form.Label>Select weekdays</Form.Label>
          <div className="d-flex flex-wrap gap-2">
            {daysOfWeek.map((day, index) => (
              <Button
                key={day}
                variant={
                  selectedWeekdays?.includes(index + 1)
                    ? "success"
                    : "secondary"
                }
                className="weekday-btn shadow-sm"
                onClick={() => handleWeekdayClick(day, index + 1)}
              >
                {day.charAt(0).toUpperCase() + day.slice(1, 3)}
              </Button>
            ))}
          </div>
          {showErrors && !areWeekdaysSelected && (
            <div className="text-danger small mt-1">
              Please select at least one weekday
            </div>
          )}
        </Form.Group>

        {/* Time range */}
        <Form.Group className="mb-3">
          <Form.Label>Enter time</Form.Label>
          <div className="d-flex align-items-center gap-2">
            <IntervalTimePicker
              value={startTime}
              onChange={(t) => handleTimeChange(t, "schedule_from_time")}
              className="shadow-sm"
            />
            <span>-</span>
            <IntervalTimePicker
              value={endTime}
              onChange={(t) => handleTimeChange(t, "schedule_to_time")}
              className="shadow-sm"
            />
          </div>
          {showErrors && !areTimesValid && (
            <div className="text-danger small mt-1">
              Please select valid start and end times (end time must be after start time)
            </div>
          )}
          {errorMessage && (
            <div className="text-danger small mt-1">
              End time should be greater than start time
            </div>
          )}
        </Form.Group>

        {/* Should be / Should not be */}
        <Form.Group
          controlId="formStatus"
          className="d-flex align-items-center my-3"
        >
          <h5 className="schedule-label">Should be</h5>
          <div className="text-left px-3">
            <label className="daz-switch mt-1">
              <input
                type="checkbox"
                onChange={() => {
                  handleChange({
                    target: {
                      name: "machine_status_condition",
                      value: !scheduleParams.machine_status_condition,
                    },
                  });
                }}
                checked={scheduleParams?.machine_status_condition}
                defaultValue={false}
              />
              <span className="slider round"></span>
            </label>
          </div>

          <h5 className="schedule-label">Should not be</h5>
          <div className="text-left px-3">
            <label className="daz-switch mt-1">
              <input
                type="checkbox"
                onChange={() => {
                  handleChange({
                    target: {
                      name: "machine_status_condition",
                      value: !scheduleParams.machine_status_condition,
                    },
                  });
                }}
                checked={!scheduleParams?.machine_status_condition}
                defaultValue={false}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </Form.Group>

        {/* Status Dropdown */}
        <Form.Group className="my-3">
          <Form.Label>Status</Form.Label>
          <DropdownButton
            variant="secondary"
            name="machine_status"
            id="dropdown-basic-button"
            title={
              scheduleParams?.machine_status?.charAt(0)?.toUpperCase() +
              scheduleParams?.machine_status?.slice(1) || "Select Status"
            }
            onSelect={handleDropdownChange}
            value={scheduleParams?.machine_status}
            defaultValue={"OFF"}
          >
            <Dropdown.Item eventKey="PRODUCTION">PRODUCTION</Dropdown.Item>
            <Dropdown.Item eventKey="OFF">OFF</Dropdown.Item>
            <Dropdown.Item eventKey="SLEEP">SLEEP</Dropdown.Item>
            <Dropdown.Item eventKey="STANDBY">STANDBY</Dropdown.Item>
          </DropdownButton>
          {showErrors && !isStatusSelected && (
            <div className="text-danger small mt-1">
              Please select a status
            </div>
          )}
        </Form.Group>
      </div>
    </>
  );
};

export default ScheduleForm1;